import { useState } from "react";
import { Gift, Share2, Loader2 } from "lucide-react";
import { useShareMe } from "@/lib/share";
import ShareOptionsModal from "@/components/ShareOptionsModal";
import { useI18n } from "@/lib/I18nContext";

export default function Share() {
  const { t } = useI18n();
  const { data, isLoading } = useShareMe();
  const [shareOpen, setShareOpen] = useState(false);

  const shareUrl = data?.share_url || "https://appfigumatch.xyz";
  const tokens = data?.figutokens_balance ?? 0;

  return (
    <div className="max-w-3xl mx-auto space-y-8" data-testid="share-page">
      <header className="space-y-2">
        <h1
          data-testid="share-heading"
          className="font-display text-3xl sm:text-4xl font-bold text-white tracking-tight"
        >
          {t("share.title")} 🚀
        </h1>
        <p className="font-body text-sm text-[#A1A1AA]">
          {t("share.subtitle")}
        </p>
      </header>

      {/* Balance card */}
      <section
        data-testid="share-balance-card"
        className="relative bg-[#0A0A0A] border border-[#E5B83A]/40 rounded-xl p-6 sm:p-8 shadow-[0_0_60px_-30px_rgba(229,184,58,0.6)]"
      >
        <p className="text-[#A1A1AA] text-xs uppercase tracking-[0.18em] font-body">
          Your Balance
        </p>
        <div className="mt-3 flex items-baseline gap-3 flex-wrap">
          <span
            data-testid="share-balance-amount"
            className="font-display text-5xl sm:text-6xl font-bold text-[#E5B83A]"
          >
            {isLoading ? (
              <Loader2 className="inline h-8 w-8 animate-spin text-[#E5B83A]/60" />
            ) : (
              tokens
            )}
          </span>
          <span className="font-body text-base text-white/80">FiguTokens</span>
        </div>
        <p
          data-testid="share-balance-sublabel"
          className="font-body text-xs text-[#A1A1AA]/80 mt-3"
        >
          FiguTokens are the official currency of FiguMatch.
        </p>
      </section>

      {/* Referral card */}
      <section
        data-testid="share-referral-card"
        className="bg-[#0A0A0A] border border-white/10 rounded-xl p-6 sm:p-8 space-y-4"
      >
        <div className="flex items-center gap-2 text-[#A1A1AA] text-xs uppercase tracking-wider font-body">
          <Gift className="h-4 w-4 text-[#E5B83A]" />
          Your share link
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            readOnly
            value={shareUrl}
            data-testid="share-link-input"
            onFocus={(e) => e.currentTarget.select()}
            className="flex-1 min-w-0 bg-[#121212] border border-white/10 rounded-md px-3 h-11 text-white font-body text-sm font-mono focus:outline-none focus:ring-1 focus:ring-[#E5B83A] focus:border-[#E5B83A]"
          />
          <button
            type="button"
            onClick={() => setShareOpen(true)}
            data-testid="share-open-options-button"
            className="h-11 px-4 rounded-md font-display font-semibold text-sm whitespace-nowrap inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#E5B83A] to-[#C9971C] text-black hover:opacity-95 transition-opacity"
          >
            <Share2 className="h-4 w-4" />
            Share with friends
          </button>
        </div>
      </section>

      <p className="font-body text-xs text-[#A1A1AA]/60 text-center">
        More ways to earn FiguTokens are coming soon. For now, enjoy your
        starter balance.
      </p>

      <ShareOptionsModal open={shareOpen} onOpenChange={setShareOpen} />
    </div>
  );
}
